module.exports = __webpack_public_path__ + "img/comodo.f5775454.png";